import { render, staticRenderFns } from "./SharePerDepartmentModal.vue?vue&type=template&id=94554da2&scoped=true&"
import script from "./SharePerDepartmentModal.vue?vue&type=script&lang=js&"
export * from "./SharePerDepartmentModal.vue?vue&type=script&lang=js&"
import style0 from "./SharePerDepartmentModal.vue?vue&type=style&index=0&id=94554da2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94554da2",
  null
  
)

export default component.exports